import axios from "axios";
import employees from "../../models/workflow/employees";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getEmployees() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/workflow/operemp`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return employees.fromJson(item);
        });
      });
  }

  new(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      operId: data.operId,
      fecDesde: data.fecDesde,
      empleados: data.empleados,
    };
    if (data.haNoEx) {
      payload = {
        ...payload,
        haNoEx: data.haNoEx,
      };
    } else if (data.fecHasta && !data.haNoEx) {
      payload = {
        ...payload,
        fecHasta: data.fecHasta,
      };
    }

    return axios.post(`${url}/workflow/operemp`, payload, { headers });
  }
  delete(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const operid = data.operId;
    return axios.delete(
      `${url}/workflow/operemp/${operid}?empid=${data.empid}&fecdesde=${data.from}`,
      { headers }
    );
  }

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const operid = data.operid;
    const empid = data.employees;
    const fecdesde = data.fromOld;
    let payload = {
      fecDesde: data.from + "T00:00:00.000Z",
    };
    if (data.haNoEx) {
      payload = {
        ...payload,
        haNoEx: data.haNoEx,
      };
    } else if (data.to && !data.haNoEx) {
      payload = {
        ...payload,
        fecHasta: data.to + "T00:00:00.000Z",
      };
    }
    return axios
      .patch(
        `${url}/workflow/operemp/${operid}&${empid}&${fecdesde}`,
        payload,
        { headers }
      )
      .then(() => {});
  }
}
export default service;
